import isNumber from 'lodash/isNumber'
import split from 'lodash/split'

const roundUp = (n, d) => (Math.round(n * Math.pow(10, d)) / Math.pow(10, d))

export const round2dec = value => {
  return isNumber(value) ? roundUp(value, 2).toFixed(2) : roundUp(parseFloat(value), 2).toFixed(2)
}

export const space1k = value => {
  if (value === undefined || value === '') {
    return value
  }
  const [ num, dec ] = split(value, '.', 2)
  return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') + '.' + dec
}



// WEBPACK FOOTER //
// ./src/filters/NumericFilters.js